// Query key factory for the campaign task board (kanban, to-do, stats, history).
import type {
  AgendaSource,
  AgendaStatusFilter,
  HotPanelCategory,
} from "@/nango/types/apps.autoleads/autoleads/TaskBoard"

export type TaskBoardFilters = {
  campaign_id: number
  q?: string
  only_actionable?: boolean
  focus_lead?: number
}

export type AgendaFilters = {
  q?: string
  source?: AgendaSource | "all"
  status?: AgendaStatusFilter
}

export const taskBoardKeys = {
  all: ["autoleads", "task-board"] as const,
  board: (filters: TaskBoardFilters) =>
    [...taskBoardKeys.all, "board", filters] as const,
  // One column's own pages, kept apart from the board so paging a column never
  // refetches the other eleven.
  column: (filters: TaskBoardFilters, columnKey: string) =>
    [...taskBoardKeys.all, "column", columnKey, filters] as const,
  stats: (campaignId: number, windowDays: number) =>
    [...taskBoardKeys.all, "stats", campaignId, windowDays] as const,
  // One task in full, with its drafted copy.
  task: (taskId: number) => [...taskBoardKeys.all, "task", taskId] as const,
  history: (campaignId: number, cardId: string) =>
    [...taskBoardKeys.all, "history", campaignId, cardId] as const,
  todo: (campaignId: number) =>
    [...taskBoardKeys.all, "todo", campaignId] as const,
  // The dated list of everything owed, both sources merged.
  agenda: (campaignId: number, filters: AgendaFilters) =>
    [...taskBoardKeys.all, "agenda", campaignId, filters] as const,
  // One contact in full: its ladder plus every colleague's state.
  contact: (campaignId: number, cardId: string) =>
    [...taskBoardKeys.all, "contact", campaignId, cardId] as const,
  notes: (campaignId: number, cardId: string) =>
    [...taskBoardKeys.all, "notes", campaignId, cardId] as const,
  hot: (campaignId: number, category: HotPanelCategory) =>
    [...taskBoardKeys.all, "hot", campaignId, category] as const,
  // Replies waiting on the whole campaign, for the CRM tab's badge.
  unreadReplies: (campaignId: number) =>
    [...taskBoardKeys.all, "unread-replies", campaignId] as const,
}
